<div [class.loader-hidden]="!show">
  <div class="loader-overlay">
    <mat-progress-spinner class="load-spinner" mode="indeterminate" *ngIf="show"></mat-progress-spinner>
  </div>
</div>
